<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  watch: {
    '$route.name': function (newVal, oldVal) {
      console.log(newVal, oldVal);
      window.scrollTo({
        top: 0,
      })
    }
  },
}
</script>
<style lang="scss">
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
